import { render, staticRenderFns } from "./GreenCardList.vue?vue&type=template&id=3840c851&scoped=true&"
import script from "./GreenCardList.vue?vue&type=script&lang=ts&"
export * from "./GreenCardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3840c851",
  null
  
)

export default component.exports